import auth from '../auth'
import rest from '../rest'

const tokenRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
  forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
};

export default {
  async getUserProfile() {
    const url = 'https://graph.microsoft.com/beta/me/';
    const options = await auth.getOptions(tokenRequest, 'GET');

    return await rest.call(url, options);
  }
}